import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import SectionsHeading from "../../SectionsHeading";
import {
  AbsoluteImage,
  GradiantDiv,
  OuterGradiantDiv,
  SecondGradiantDiv,
} from "../../../Styles/style";
import Paragraph from "../../Paragraph";

const GridWraper = styled(Grid)`
  width: 100%;
  height: 100%;
  display: flex;
  /* flex-direction:column; */
  justify-content: flex-end;
  align-items: center;
  padding: 100px 0;
  column-gap: 50px;
  @media (max-width: 899px) {
    display: none;
  }
`;
const MobileGridWraper = styled(Grid)`
  width: 100%;
  height: 100%;
  display: none;
  /* flex-direction:column; */
  justify-content: center;
  align-items: center;
  padding: 100px 0;
  column-gap: 50px;
  @media (max-width: 899px) {
    display: flex;
  }
`;
const ContinerWraper = styled(Container)`
  background: #070f29;
  height: auto;
  width: 100%;
  padding: 0 !important;
`;
const GridItem = styled(Grid)`
  & .marginDiv {
    background: #070f29;
  }
  :hover {
    & .marginDiv {
      background: linear-gradient(to top, #fff, transparent);
    }
  }
`;
const GridEmpty = styled(Grid)`
  @media (max-width: 899px) {
    display: none;
  }
`;
const RoadmapSection = () => {
  return (
    <ContinerWraper maxWidth="xxl" id="roadmap">
      <Container>
        <GridWraper container>
          <Grid item xs={12}>
            <SectionsHeading ta="center" data-aos="zoom-in">
              Roadmap
            </SectionsHeading>
          </Grid>
          <GridItem item xs={10} sm={5} md={3}>
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv ai="flex-start" p="10px">
                  <AbsoluteImage
                    t="41%"
                    l="-13%"
                    w="40px"
                    src="./Images/bottomdot.png"
                  />
                  <Paragraph
                    fs="16px"
                    p="10px 0 10px 10px"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Phase 2
                  </Paragraph>
                  <Paragraph fs599="12px" p="0px 0 0px 10px">
                    Expand the community through targeted marketing and
                    partnerships.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridItem item xs={10} sm={5} md={3}>
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv ai="flex-start" p="10px">
                  <AbsoluteImage
                    t="41%"
                    l="-13%"
                    w="40px"
                    src="./Images/bottomdot.png"
                  />
                  <Paragraph
                    fs="16px"
                    p="10px 0 10px 10px"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Phase 4
                  </Paragraph>
                  <Paragraph fs599="12px" p="0px 0 0px 10px">
                    Focus on scaling and sustainability, with an eye toward
                    global adoption.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridEmpty item xs={12} sx={{ position: "relative" }}>
            <hr
              style={{
                width: "80%",
                height: "5px",
                background: "#fff",
                margin: "30px 0",
              }}
            />
            <AbsoluteImage
              t="-10%"
              className="shadow"
              w="100px"
              src="./Images/personimage.png"
            />
            <Paragraph
              fs="16px"
              p="30px 0 10px 30px"
              fs599="14px"
              fm="PoppinsSB"
            >
              Idea
            </Paragraph>
          </GridEmpty>
          <GridItem item xs={10} sm={5} md={3}>
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv ai="flex-start" p="10px">
                  <AbsoluteImage
                    t="-90%"
                    l="-18%"
                    w="50px"
                    src="./Images/topdot.png"
                  />
                  <Paragraph
                    fs="16px"
                    p="10px 0 10px 10px"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Phase 1
                  </Paragraph>
                  <Paragraph fs599="12px" p="0px 0 0px 10px">
                    Engage with the community, fostering awareness and early
                    adoption.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridItem item xs={10} sm={5} md={3}>
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv ai="flex-start" p="10px">
                  <AbsoluteImage
                    t="-90%"
                    l="-18%"
                    w="50px"
                    src="./Images/topdot.png"
                  />
                  <Paragraph
                    fs="16px"
                    p="10px 0 10px 10px"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Phase 3
                  </Paragraph>
                  <Paragraph fs599="12px" p="0px 0 0px 10px">
                    Develop strategic partnerships to increase token utility and
                    integration.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridEmpty item xs={10} sm={5} md={2}></GridEmpty>
        </GridWraper>
        <MobileGridWraper container>
          <Grid item xs={12}>
            <SectionsHeading ta="center" data-aos="zoom-in">
              Roadmap
            </SectionsHeading>
          </Grid>
          <GridItem
            item
            xs={10}
            sm={8}
            sx={{ margin: "20px 0" }}
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv ai="flex-start" p="10px">
                  <Paragraph
                    fs="16px"
                    p="10px 0 10px 10px"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Phase 1
                  </Paragraph>
                  <Paragraph fs599="12px" p="0px 0 0px 10px">
                    Engage with the community, fostering awareness and early
                    adoption.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridItem
            item
            xs={10}
            sm={8}
            sx={{ margin: "20px 0" }}
            data-aos="fade-up"
            data-aos-duration="1300"
          >
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv ai="flex-start" p="10px">
                  <Paragraph
                    fs="16px"
                    p="10px 0 10px 10px"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Phase 2
                  </Paragraph>
                  <Paragraph fs599="12px" p="0px 0 0px 10px">
                    Expand the community through targeted marketing and
                    partnerships.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridItem
            item
            xs={10}
            sm={8}
            sx={{ margin: "20px 0" }}
            data-aos="fade-up"
            data-aos-duration="1600"
          >
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv ai="flex-start" p="10px">
                  <Paragraph
                    fs="16px"
                    p="10px 0 10px 10px"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Phase 3
                  </Paragraph>
                  <Paragraph fs599="12px" p="0px 0 0px 10px">
                    Develop strategic partnerships to increase token utility and
                    integration.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridItem
            item
            xs={10}
            sm={8}
            sx={{ margin: "20px 0" }}
            data-aos="fade-up"
            data-aos-duration="1900"
          >
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv ai="flex-start" p="10px">
                  <Paragraph
                    fs="16px"
                    p="10px 0 10px 10px"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Phase 4
                  </Paragraph>
                  <Paragraph fs599="12px" p="0px 0 0px 10px">
                    Focus on scaling and sustainability, with an eye toward
                    global adoption.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridEmpty item xs={10} sm={5} md={2}></GridEmpty>
        </MobileGridWraper>
      </Container>
    </ContinerWraper>
  );
};

export default RoadmapSection;
